import { useContext } from "react";
import { ActiveEntityContext } from "../context/active-entity-context";
import { useEntity } from "./use-entity";
export function useActiveEntity() {
  var entity = useEntity();
  var providedEntity = useContext(ActiveEntityContext);
  return providedEntity || entity;
}
;